import { Checkbox } from 'antd';
import './CheckboxComponent.scss';
import { cn } from '../../../utils/string/cn.utils';

const CheckboxComponent = ({ children, ...props }) => {
  return (
    <Checkbox
      {...props}
      className={cn(
        '[&_.ant-checkbox-inner]:bg-fills-white [&_.ant-checkbox-inner]:border-outline-default-primary [&_.ant-checkbox-inner]:rounded-[4px] [&_.ant-checkbox-inner]:w-18 [&_.ant-checkbox-inner]:h-18',
        '[&_.ant-checkbox-inner]:hover:border-primary-primary',
        '[&_.ant-checkbox-checked_.ant-checkbox-inner]:hover:bg-primary-primaryVarient1',
        '[&_.ant-checkbox-checked_.ant-checkbox-inner]:bg-primary-primary',
        '[&_.ant-checkbox-checked_.ant-checkbox-inner::after]:border-white',
        props.className
      )}
    >
      {children}
    </Checkbox>
  );
};

export default CheckboxComponent;
